import React, {Component} from 'react';
import { Element as AnchorElement } from 'react-scroll';
import Carousel from 'nuka-carousel';

class UseCases extends Component {
    render() {
        const countArray = Array.apply(null, Array(9));
        const useCase1Carousel = (
            <Carousel
                autoplay={true} 
                wrapAround={true} 
                renderCenterLeftControls={({ previousSlide }) => (
                    <div className="icon is-large" onClick={previousSlide}>
                        <span className="fa-stack">
                            <i className="fas fa-circle fa-stack-2x has-text-grey-lighter"></i>
                            <i className="fas fa-chevron-left fa-stack-1x has-text-grey-dark"></i>
                        </span>
                    </div>
                )} 
                renderCenterRightControls={({ nextSlide }) => (
                    <div className="icon is-large" onClick={nextSlide}>
                        <span className="fa-stack">
                            <i className="fas fa-circle fa-stack-2x has-text-grey-lighter"></i>
                            <i className="fas fa-chevron-right fa-stack-1x has-text-grey-dark"></i>
                        </span>
                    </div>
                )} 
                renderBottomCenterControls={({ currentSlide }) => (
                    <ul className="HomeUseCaseCarouselDots">
                        {
                            countArray.map((value, index) => {
                                var _className = '';
                                if ( index === currentSlide ) {
                                    _className = 'active';
                                }
                                return (
                                    <li key={`UseCase1_${index+1}_Dot`} className={_className}></li>
                                );
                            })
                        }
                    </ul>
                )} >
                {
                    countArray.map((value, index) => {
                        return (
                            <img key={`UseCase1_${index+1}_Image`} src={`/Images/used_case_1/${index + 1}.jpg`} alt={`Use case 1 - ${index + 1}`} width="1066" height="800" />
                        );
                    })
                }
            </Carousel>
        );
        return ( 
            <section className="HomeUseCases section is-medium">
                <AnchorElement className="HomeUseCasesAnchorPoint" name="AnchorPoint"></AnchorElement>
                <div className="container has-text-centered">
                    <h2 className="SectionTitle title has-text-primary is-size-2 is-size-4-mobile">ประโยชน์ของภาพจากโดรน</h2>
                </div>
                <div className="HomeUseCase columns">
                    <div className="column is-7-desktop">
                        {useCase1Carousel}
                    </div>
                    <div className="column">
                        <div className="HomeUseCaseContent content">
                            <h4 className="title is-size-4 is-size-5-mobile">เส้นชันความสูงของพื้นที่</h4>
                            <p>แผนที่ ที่ผนวกกับค่าระดับความสูงของพื้นดินและรายละเอียดต่างๆ ที่ลากไปตามพื้นภูมิประเทศบนแผนที่ ทั้งที่เป็นธรรมชาติ และที่มนุษย์สร้างขึ้น ที่ทุกเส้นแสดงค่าความสูงในแนวตั้ง ทำให้เราสามารถทราบค่าความสูงได้แม้เรามองในมุมมองแนวดิ่ง 2 มิติ</p>
                        </div>
                    </div>
                </div>
                <div className="HomeUseCase columns is-reversed">
                    <div className="column is-7-desktop">
                        <video autoPlay="autoplay" muted="muted" loop="loop">
                            <source src="/Videos/used_case_2.mp4" type="video/mp4" />
                        </video>
                    </div>
                    <div className="column">
                        <div className="HomeUseCaseContent content">
                            <h4 className="title is-size-4 is-size-5-mobile">การวิเคราะห์ความหนาแน่นของพื้นที่</h4>
                            <p>พื้นที่ที่กว้างใหญ่มักมีประสิทธิภาพต่ำในการเฝ้าสังเกตพื้นที่และการสำรวจ นำมาซึ่งอุปสรรคใหญ่ที่ต้องสูญเสียงบประมาณมหาศาล แต่ ณ เวลานี้โดรนสามารถเก็บภาพและผลิตเป็นแผนที่ได้ในพื้นที่ขนาดใหญ่และมีความละเอียดที่คมชัดระดับเซนติเมตร จึงเป็นตัวช่วยหนึ่งในการวิเคราะห์ผังเมืองและการสำรวจสำมะโนครัวในปัจจุบัน</p>
                        </div>
                    </div>
                </div>
                <div className="HomeUseCase columns">
                    <div className="column is-7-desktop">
                        <video autoPlay="autoplay" muted="muted" loop="loop">
                            <source src="/Videos/used_case_3.mp4" type="video/mp4" />
                        </video>
                    </div>
                    <div className="column">
                        <div className="HomeUseCaseContent content">
                            <h4 className="title is-size-4 is-size-5-mobile">การติดตามการก่อสร้าง</h4>
                            <p>การติดตามผลการปฏิบัติงานของโครงการก่อสร้าง โดยการนำภาพถ่ายแผนที่ความละเอียดสูง ซึ่งช่วยให้ผู้ติดตามตั้งแต่ต้น ขณะก่อสร้าง และหลังก่อสร้างเสร็จสิ้นสมบูรณ์ทำให้ผู้ที่มีหน้าที่ที่เกี่ยวข้องสามารถตรวจสอบและติดตามผลได้ดีมากยิ่งขึ้น ช่วยลดปัญหาหรือข้อผิดพลาดต่างๆ รวมไปถึงเพิ่มประสิทธิภาพในการทำงานให้เป็นไปตามแบบแผนที่กำหนดไว้ได้อย่างมีประสิทธิผล</p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default UseCases;


// WEBPACK FOOTER //
// ./src/PageHome/_UseCases.js